export default __webpack_public_path__ + "static/media/Letter K.7fb456e8.mov";